let obj = {};
//性别
obj.sexOptions = [
  {
    name: '男',
    value: 'M'
  },
  {
    name: '女',
    value: 'F'
  }
];
obj.guarantPre = [
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
export default { ...obj };
